import gql from 'graphql-tag';

const QUERY_HOMECARDS = gql`
  query Homecards($ids: [Int], $locale: String = "en") {
    homecards(homecardIds: $ids, locale: $locale) {
      checked
      currencyIsoCode
      firstAvailableDate
      id
      city
      isInstantBooking
      noSecurityDeposit
      hasDepositProtection
      isFavorite
      mainPhotoUrl
      reviews {
        ratingAverage
      }
      title
      description
      type
      url
      features
      area
      roomArea
      offers {
        discountType
        discountValue
      }
      allowsPermanentContract
      numberOfBathrooms
      numberOfBedrooms
      isBestChoice
      location
      landlordId
      so
      photoIds
      otherPropertyPhotoIds
      displayPrice
      billsIncluded
    }
  }
`;

const getHomecardsQuery = client => (ids, locale) =>
  client.query({
    query: QUERY_HOMECARDS,
    variables: { ids, locale },
    fetchPolicy: 'cache-first'
  });

export default getHomecardsQuery;
